import { ProcessedTelSysProfile } from '../../Common/Types/Types'
import {
    DEFAULT_MAX_ALLOWED_PARTITIONS_COUNT,
    MAX_ALLOWED_PARTITIONS_COUNT_LICENCE_VALUE,
    TEL_SYS_TYPE_VALUE_MAP,
    TelSysTypes
} from '../Constants/Constants'
import { isStringNotEmpty } from '../../../NonReact/utils/GlobalFunctions'

/**
 * Reads the maximum allowed partition entries for MS Teams telephony servers out of the
 * licence file TelSys profiles.
 *
 * <p>The value originates from the MaxAllowedPartitionsCount licence value on the MS Teams
 * TelSys profile in AppLicense.xml, which the backend also applies when saving a TelSys.
 *
 * @param telSysProfiles TelSys profiles loaded from the licence file, may be null or empty.
 * @returns The licensed maximum, or DEFAULT_MAX_ALLOWED_PARTITIONS_COUNT when the licence value
 *          is missing or is not a positive whole number.
 */
export const getMaxAllowedPartitionsCount = (telSysProfiles: Nullable<ProcessedTelSysProfile[]>): number => {
    const licenceValue: Definable<string> = telSysProfiles?.find(
        (telSysProfile: ProcessedTelSysProfile): boolean =>
            telSysProfile?.type === TEL_SYS_TYPE_VALUE_MAP[TelSysTypes.MS_TEAMS]
    )?.LicenseValues?.[MAX_ALLOWED_PARTITIONS_COUNT_LICENCE_VALUE]

    if (!isStringNotEmpty(licenceValue)) return DEFAULT_MAX_ALLOWED_PARTITIONS_COUNT

    const maxAllowedPartitionsCount: number = Number(licenceValue)

    if (!Number.isInteger(maxAllowedPartitionsCount) || maxAllowedPartitionsCount <= 0)
        return DEFAULT_MAX_ALLOWED_PARTITIONS_COUNT

    return maxAllowedPartitionsCount
}
